import {  fetchConToken } from "../helpers/fetch"

const getAllTipoDocumentsPag = async (currentPage:any,numberData:any,options: any) => {
  const queryString = new URLSearchParams(options).toString();

  const resp = await fetchConToken(
    `tipodocument/paginado/${currentPage}/${numberData}?${queryString}`,
    {},
    'GET'
  );

  const body = await resp.json();

  return body;
};

const crearTipoDocumentData = async (data: any) => {
  const resp = await fetchConToken(
      `tipodocument/add`,
      data,
      'POST'
  );
  const body = await resp.json();

  return body;
}

const updateTipoDocumentData = async (id: string, updatedData: any) => {
  const resp = await fetchConToken(
      `tipodocument/${id}`,
      updatedData,
      'PUT'
  );
  const body = await resp.json();

  return body;
}

const getTipoDocumentes = async () => {
  const resp = await fetchConToken(
      `tipodocument/gettipodocumentes/`,
      {},
      'GET'
  );
  const body = await resp.json();

  return body;
}

const getTipoDocumentById = async (url: string) => {

  const resp = await fetchConToken(
      `tipodocument/gettipodocumentbyurl/${url}`,
      {},
      'GET'
  );

  const body = await resp.json();

  return body;
};

const deleteTipoDocument = async (id:string) => {
  const resp = await fetchConToken(`tipodocument/${id}`, {}, 'DELETE')

  const body = await resp.json()
  return body
}

const activarTipoDocument = async (id:string) => {
  const resp = await fetchConToken(`tipodocument/activar/${id}`, {}, 'PUT')

  const body = await resp.json()
  return body
}
  
export {
    getAllTipoDocumentsPag,
    deleteTipoDocument,
    activarTipoDocument,
    crearTipoDocumentData,
    updateTipoDocumentData,
    getTipoDocumentes,
    getTipoDocumentById
};